import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import Button from "@mui/material/Button"

import Row from "../Row"

export default function Pagination({
  totalCount,
  pageSize,
  pageIndex,
  onPageChanged,
  disabled,
}) {
  const pageCount = Math.min(
    Math.ceil(totalCount / pageSize),
    1e4 / pageSize - 1
  )

  return (
    <Row sx={{ columnGap: 1 }}>
      <Button
        variant="outlined"
        color="inherit"
        startIcon={<ArrowBackIcon />}
        disabled={disabled || pageIndex === 1}
        onClick={() => onPageChanged(pageIndex - 1)}
      >
        Previous
      </Button>
      <Button
        variant="outlined"
        color="inherit"
        endIcon={<ArrowForwardIcon />}
        disabled={disabled || pageIndex >= pageCount}
        onClick={() => onPageChanged(pageIndex + 1)}
      >
        Next
      </Button>
    </Row>
  )
}
